// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fmtz9","colMin":"styles_colMin__NjONy"};